import 'babel-polyfill'
import Vue from 'vue'
import VueStash from 'vue-stash'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import VueCookies from 'vue-cookies'
import './assets/css/main.css'

Vue.use(VueCookies)
Vue.use(VueStash)
Vue.config.productionTip = false

// set default config
Vue.$cookies.config('7d')

new Vue({
  vuetify,
  'router': router,
  i18n,

  data: {
    store: {
      mapboxAccessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      google_geocoding: process.env.VUE_APP_GOOGLE_GEOCODING,
      google_places: process.env.VUE_APP_GOOGLE_PLACES,
      backendAPI: process.env.VUE_APP_BACKEND_API,
      backendURL: process.env.VUE_APP_BACKEND_URL,
      mapbox_geocoding: process.env.VUE_APP_MAPBOX_GEOCODING,
      map: null,
      mapid:'',
      mapParameters:{},
      searchedAddress:'',
      searchedAddressText:'',
      mapZones: {},
      searchedAddressStruct:{},
      mapMarker: null,
      lastCalculationMarker: null,
      lastCalculation: null,
      position: [],
      mapZone: '',
      zoom: 15,
      windows:'',
      dialog: false,
      userToken: '',
      userEmail: '',
      lang: 'fr',
      legends: null,
      calculation:{},
      icons:{
        'close':'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z',
        
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
